import React from "react";
import { useNavigate } from "react-router-dom";

function Refused() {
  const navigate = useNavigate();
  return (
    <div className="text-center">
      <h1>Vous n'etes pas autorisé.</h1>
      <button
        className="btn bg-primary"
        onClick={() => navigate("/tableau-bord")}>
        Retour
      </button>
    </div>
  );
}

export default Refused;
